import { create } from "zustand";

export const useUiStore = create((set) => ({
  pickerOpen: false,
  profileOpen: false,
  setPickerOpen: (pickerOpen) => set({ pickerOpen: typeof pickerOpen === "function" ? pickerOpen(useUiStore.getState().pickerOpen) : pickerOpen }),
  setProfileOpen: (profileOpen) => set({ profileOpen: typeof profileOpen === "function" ? profileOpen(useUiStore.getState().profileOpen) : profileOpen }),
}));

export const usePickerOpen = () => useUiStore((s) => s.pickerOpen);
export const useSetPickerOpen = () => useUiStore((s) => s.setPickerOpen);
export const useProfileOpen = () => useUiStore((s) => s.profileOpen);
export const useSetProfileOpen = () => useUiStore((s) => s.setProfileOpen);
